class Facets {
	constructor(domNode = document) {
		this.wrap = domNode;
		this.facetsWrap = this.wrap.querySelector('#facetsWrap');
		this.facetsToggles = this.wrap.querySelector('#facetsToggles');

		if (this.facetsWrap && this.facetsToggles) {
			this.checkCloseFacetGroups();
			this.checkRemoveFacetToggle();
			this.bindEvents();
		}
	}

	bindEvents() {
		this.facetsWrap.addEventListener('click', e => this.triggerClick(e));
		this.facetsToggles.addEventListener('click', e => this.triggerClick(e));
		this.facetsWrap.addEventListener(
			'change',
			e => this.triggerChange(e),
			false,
		);
	}

	triggerClick(e) {
		const button = e.target.closest('button');

		if (button) {
			if (isFacetShowMore(button)) {
				return this.doFacetShowMoreToggle(button);
			}
			if (isFacetToggle(button, '#facetsToggles')) {
				return this.doFacetCollectionToggle(button);
			}
			if (isFacetToggle(button, '#facetsWrap')) {
				return this.doFacetGroupToggle(button);
			}
		}

		return null;
	}

	triggerChange(e) {
		if (e.target.type === 'checkbox') {
			if (e.target.form.getAttribute('data-redirect') === 'true') {
				window.location.assign(e.target.form.action);
			} else {
				e.target.form.submit();
			}
		}
	}

	doFacetCollectionToggle(toggle) {
		const target = getToggleTarget(toggle);
		this.closeSiblingFacetCollections(target);

		triggerToggle(toggle);
	}

	doFacetGroupToggle(toggle) {
		triggerToggle(toggle);
	}

	doFacetShowMoreToggle(toggle) {
		const target = toggle.closest('.facet');
		doToggle(target, 'facet--show-all');
	}

	closeSiblingFacetCollections(target) {
		const cssClass = 'facets--is-open';
		const facetCollections = this.facetsWrap.getElementsByClassName(cssClass);

		Array.from(facetCollections).forEach(
			collection =>
				collection !== target && collection.classList.remove(cssClass),
		);
	}

	checkCloseFacetGroups() {
		const { device } = window.od;

		if (device() !== 'lg') {
			const cssClass = 'facet--is-open';
			const openFacets = this.facetsWrap.getElementsByClassName(cssClass);

			Array.from(openFacets).forEach(facet => facet.classList.remove(cssClass));
		}
	}

	checkRemoveFacetToggle() {
		const customFacets = this.wrap.querySelector('#customFacets');
		const customFacetsToggle = this.wrap.querySelector('#facetsTogglesCustom');

		if (customFacets && !customFacets.innerHTML.length) {
			customFacets.remove();
			customFacetsToggle.remove();
		}
	}
}

function isFacetToggle(target, selector) {
	const toggle = getFacetToggle(target);
	return toggle && toggle.closest(selector);
}

function isFacetShowMore(button) {
	return button.hasAttribute('data-show-more');
}

function getFacetToggle(target) {
	const button = target.closest('button');
	return button && button.hasAttribute('data-target') ? button : null;
}

function triggerToggle(toggle) {
	const target = getToggleTarget(toggle);
	const cssClass = toggle.getAttribute('data-toggle');
	doToggle(target, cssClass);
}

function getToggleTarget(el) {
	const targetID = el.getAttribute('data-target');
	return document.querySelector(targetID);
}

function doToggle(el, cssClass) {
	const open = () => el.classList.add(cssClass);
	const close = () => el.classList.remove(cssClass);

	return (el.classList.contains(cssClass) ? close : open)();
}

export default Facets;
